import {
  type AvailableFreeGiftV2,
  useGetCartItemsQuery,
  useGetCustomerCartIdQuery,
} from "@jti/store/slices/magentoApiSlice";

export const useAvailableFreeGifts = () => {
  const { data: cartId, isLoading: isLoadingCartId, error: cartIdError } = useGetCustomerCartIdQuery();

  const cartIdValue = cartId?.customerCart?.id;

  const {
    data,
    isLoading: isLoadingCartItems,
    isFetching,
    error: cartItemsError,
  } = useGetCartItemsQuery({ cartId: cartIdValue! }, { skip: !cartIdValue || !!isLoadingCartId || !!cartIdError });

  const isLoading = !!isLoadingCartId || !!isLoadingCartItems;
  const error = cartIdError || cartItemsError;

  return {
    data: (data?.availableFreeGifts ?? []) as AvailableFreeGiftV2[],
    isLoading,
    isFetching,
    error,
  };
};
